import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from './http.client';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {AppSettings}from '../_models/app.settings';
 
@Injectable()
export class AuthService {
    constructor(private http: HttpClient) { }

    login(email: string, password: string){
        return this.http
                    .get(
                        AppSettings.API_INSCRIPCIONES+'/usuario', 
                        {
                            "Authorization": "Basic "+btoa(email+':'+password)
                        }
                    )
                    .map((resp: Response) => resp.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/auth.service.ts